const GET_DETAIL_OTHER_CUSTOMER_BY_ID = 'GET_DETAIL_OTHER_CUSTOMER_BY_ID'
const GET_DETAIL_OTHER_CUSTOMER_BY_ID_SUCCESS = 'GET_DETAIL_OTHER_CUSTOMER_BY_ID_SUCCESS'

const PUT_OTHER_CUSTOMER = 'PUT_OTHER_CUSTOMER'
const PUT_OTHER_CUSTOMER_SUCCESS = 'PUT_OTHER_CUSTOMER_SUCCESS'

const POST_OTHER_CUSTOMER = 'POST_OTHER_CUSTOMER'
const POST_OTHER_CUSTOMER_SUCCESS = 'POST_OTHER_CUSTOMER_SUCCESS'

const GET_OTHER_CUSTOMER_PAGES = 'GET_OTHER_CUSTOMER_PAGES'
const GET_OTHER_CUSTOMER_PAGES_SUCCESS = 'GET_OTHER_CUSTOMER_PAGES_SUCCESS'

const GET_OTHER_CUSTOMER_HISTORIES_PAGES = 'GET_OTHER_CUSTOMER_HISTORIES_PAGES'
const GET_OTHER_CUSTOMER_HISTORIES_PAGES_SUCCESS = 'GET_OTHER_CUSTOMER_HISTORIES_PAGES_SUCCESS'


const GET_DETAIL_IGARASHI_CUSTOMER_BY_ID = 'GET_DETAIL_IGARASHI_CUSTOMER_BY_ID'
const GET_DETAIL_IGARASHI_CUSTOMER_BY_ID_SUCCESS = 'GET_DETAIL_IGARASHI_CUSTOMER_BY_ID_SUCCESS'

const PUT_IGARASHI_CUSTOMER = 'PUT_IGARASHI_CUSTOMER'
const PUT_IGARASHI_CUSTOMER_SUCCESS = 'PUT_IGARASHI_CUSTOMER_SUCCESS'

const POST_IGARASHI_CUSTOMER = 'POST_IGARASHI_CUSTOMER'
const POST_IGARASHI_CUSTOMER_SUCCESS = 'POST_IGARASHI_CUSTOMER_SUCCESS'

const GET_IGARASHI_CUSTOMER_PAGES = 'GET_IGARASHI_CUSTOMER_PAGES'
const GET_IGARASHI_CUSTOMER_PAGES_SUCCESS = 'GET_IGARASHI_CUSTOMER_PAGES_SUCCESS'

const GET_IGARASHI_CUSTOMER_HISTORIES_PAGES = 'GET_IGARASHI_CUSTOMER_HISTORIES_PAGES'
const GET_IGARASHI_CUSTOMER_HISTORIES_PAGES_SUCCESS = 'GET_IGARASHI_CUSTOMER_HISTORIES_PAGES_SUCCESS'




const CustomerType = {
  GET_DETAIL_OTHER_CUSTOMER_BY_ID,
  GET_DETAIL_OTHER_CUSTOMER_BY_ID_SUCCESS,

  PUT_OTHER_CUSTOMER,
  PUT_OTHER_CUSTOMER_SUCCESS,

  POST_OTHER_CUSTOMER,
  POST_OTHER_CUSTOMER_SUCCESS,

  GET_OTHER_CUSTOMER_PAGES,
  GET_OTHER_CUSTOMER_PAGES_SUCCESS,

  GET_OTHER_CUSTOMER_HISTORIES_PAGES,
  GET_OTHER_CUSTOMER_HISTORIES_PAGES_SUCCESS,


  GET_DETAIL_IGARASHI_CUSTOMER_BY_ID,
  GET_DETAIL_IGARASHI_CUSTOMER_BY_ID_SUCCESS,

  PUT_IGARASHI_CUSTOMER,
  PUT_IGARASHI_CUSTOMER_SUCCESS,

  POST_IGARASHI_CUSTOMER,
  POST_IGARASHI_CUSTOMER_SUCCESS,

  GET_IGARASHI_CUSTOMER_PAGES,
  GET_IGARASHI_CUSTOMER_PAGES_SUCCESS,

  GET_IGARASHI_CUSTOMER_HISTORIES_PAGES,
  GET_IGARASHI_CUSTOMER_HISTORIES_PAGES_SUCCESS

}

export default CustomerType
